import React, { useState, useEffect } from 'react';
import { Table, Tag, Form, Input, Select, Button, Space, DatePicker, message } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import { getOperationLogs } from '../../../services/api';

// 操作类型前缀映射：搜索时后端用 LIKE '{prefix}%' 匹配
const actionGroups = [
  { prefix: '登录', label: '登录', color: 'default' },
  { prefix: '新增', label: '新增', color: 'green' },
  { prefix: '更新', label: '更新', color: 'blue' },
  { prefix: '修改', label: '修改', color: 'blue' },
  { prefix: '删除', label: '删除', color: 'red' },
  { prefix: '重置', label: '重置', color: 'purple' },
  { prefix: '分配', label: '分配', color: 'orange' },
  { prefix: '批量', label: '批量', color: 'orange' },
  { prefix: '保存', label: '保存', color: 'cyan' },
  { prefix: '发布', label: '发布', color: 'geekblue' }
];
const actionOptions = actionGroups.map(g => ({ label: g.label, value: g.prefix }));
const getActionColor = (action) => {
  const g = actionGroups.find(g => action.startsWith(g.prefix));
  return g ? g.color : 'default';
};

export default function OperationLog() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);
  const [filters, setFilters] = useState({});
  const [searchForm] = Form.useForm();

  const fetchData = async (extraParams = {}) => {
    setLoading(true);
    try {
      const params = { page, pageSize: 20, ...filters, ...extraParams };
      const res = await getOperationLogs(params);
      setData(res.data.list);
      setTotal(res.data.total);
    } catch (err) { message.error(err.message); }
    setLoading(false);
  };

  useEffect(() => { fetchData(); }, [page, filters]);

  const handleSearch = async () => {
    const values = await searchForm.validateFields().catch(() => {});
    if (!values) return;
    const params = {};
    if (values.username) params.username = values.username;
    if (values.action) params.action = values.action;
    if (values.target) params.target = values.target;
    if (values.dateRange) {
      params.from = values.dateRange[0].format('YYYY-MM-DD');
      params.to = values.dateRange[1].format('YYYY-MM-DD');
    }
    setFilters(params);
    setPage(1);
  };

  const handleReset = () => {
    searchForm.resetFields();
    setFilters({});
    setPage(1);
  };

  const columns = [
    { title: '操作人', dataIndex: 'username', width: 100 },
    { title: '操作类型', dataIndex: 'action', width: 100, render: (v) => <Tag color={getActionColor(v)}>{v}</Tag> },
    { title: '操作对象', dataIndex: 'target', width: 120 },
    { title: '详情', dataIndex: 'detail', ellipsis: true },
    { title: 'IP', dataIndex: 'ip', width: 130 },
    { title: '时间', dataIndex: 'createdAt', width: 180, render: (v) => new Date(v).toLocaleString() },
  ];

  return (
    <div>
      <Form form={searchForm} layout="inline" style={{ marginBottom: 16 }}>
        <Form.Item name="username"><Input placeholder="操作人" allowClear /></Form.Item>
        <Form.Item name="action"><Select placeholder="操作类型" allowClear options={actionOptions} style={{ width: 120 }} /></Form.Item>
        <Form.Item name="target"><Input placeholder="操作对象" allowClear /></Form.Item>
        <Form.Item name="dateRange"><DatePicker.RangePicker allowClear /></Form.Item>
        <Form.Item>
          <Space>
            <Button type="primary" icon={<SearchOutlined />} onClick={handleSearch}>搜索</Button>
            <Button onClick={handleReset}>重置</Button>
          </Space>
        </Form.Item>
      </Form>
      <Table dataSource={data} columns={columns} rowKey="id" loading={loading} size="small"
        pagination={{ current: page, total, pageSize: 20, onChange: setPage, showTotal: (t) => `共 ${t} 条` }} />
    </div>
  );
}
